import { Wrench, Shield, Car, Award } from "lucide-react";

export const ProtectionFeatures = () => {
  return (
    <section className="py-12 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 animate-fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-6">
            Expert Auto Insurance Services
          </h2>
          <p className="text-lg text-neutral max-w-2xl mx-auto">
            Our team of experienced agents will help you find the perfect coverage for your vehicle and driving needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white p-8 rounded-lg shadow-sm animate-scale-in" style={{ animationDelay: "0.2s" }}>
            <h3 className="text-2xl font-semibold text-primary-dark mb-4">
              Vehicle Protection Features
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Wrench className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h4 className="font-medium">Mechanical Breakdown Coverage</h4>
                  <p className="text-neutral">Protection for unexpected repairs and mechanical failures.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Shield className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h4 className="font-medium">Gap Insurance</h4>
                  <p className="text-neutral">Coverage for the difference between your car's value and loan balance.</p>
                </div>
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-sm animate-scale-in" style={{ animationDelay: "0.4s" }}>
            <h3 className="text-2xl font-semibold text-primary-dark mb-4">
              Additional Benefits
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Award className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h4 className="font-medium">Safe Driver Discounts</h4>
                  <p className="text-neutral">Rewards for maintaining a clean driving record.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Car className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h4 className="font-medium">Multi-Vehicle Savings</h4>
                  <p className="text-neutral">Special rates when insuring multiple vehicles.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};